import type {
  AboutPageDefaultContentTemplateDynamicZone,
  ComponentFrameworkFrameworkItem,
  Maybe,
  RespectFrameworkPageQuery,
  RespectFrameworkPageQueryVariables,
} from '@edwin-group/cj-graphql/generated/graphql';
import RespectAccordion from './componentes';
import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { QUERY_RESPECT_FRAMEWORK_PAGE } from '@edwin-group/cj-graphql';
import Container from '@/components/Container';
import PageHeader from '@/components/PageHeader';
import DefaultContentTemplate from '@/components/DefaultContentTemplate';

const RESPECTFrameworkPage = () => {
  const { data: page, loading } = useQueryCacheAndNetwork<
    RespectFrameworkPageQuery,
    RespectFrameworkPageQueryVariables
  >(QUERY_RESPECT_FRAMEWORK_PAGE);

  const template = page?.respectFramework?.DefaultContentTemplate || null;

  if (loading) {
    return null;
  }

  return (
    <>
      <Container className="mt-sh-60 !gap-y-0">
        <div className="col-span-12 gap-4 lg:col-start-3 lg:col-end-11">
          <PageHeader title={page?.respectFramework?.pageTitle || ''} url="/" type="none" />
        </div>
        {template && template.length ? (
          <div className="col-span-12 aspect-video gap-4 lg:col-start-3 lg:col-end-11">
            <DefaultContentTemplate
              fitContent
              content={template as Array<Maybe<AboutPageDefaultContentTemplateDynamicZone>>}
              idBodyDivider={false}
            />
          </div>
        ) : null}
        <div className="col-span-12 aspect-video gap-4 lg:col-start-3 lg:col-end-11">
          <RespectAccordion
            frameworkItems={page?.respectFramework?.frameworkItems as ComponentFrameworkFrameworkItem[]}
            allowMultiple
            defaultOpenIndex={-1}
          />
        </div>
      </Container>
    </>
  );
};

export default RESPECTFrameworkPage;
